import { ImageLinkSliderSlickOnce, ImageLinkSliderSlickTwice } from '../../../js/src/__utils/sliders';
import ImageLinkSlider from '../../../js/src/__page/imageLinkSlider';

// GLOBAL APP CONTROLLER
const controller = {
    init() {
        ImageLinkSliderSlickOnce.init();
        ImageLinkSliderSlickTwice.init();
        ImageLinkSlider.init();
    },
    loaded() {},
    resized() {
        ImageLinkSliderSlickOnce.resize();
        ImageLinkSliderSlickTwice.resize();
    },
    scrolled() {},
    keyDown(e) {},
    mouseUp(e) {},
};
export default controller;
